import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { addHoliday, updateHoliday, fetchHolidays } from "../../redux/holidaySlice";

const HolidayModal = ({ isOpen, onClose, onSubmit, holiday }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: { name: "", start: "", end: "", description: "" },
  });
  const dispatch = useDispatch();

  const submitForm = async (data) => {
    try {
      if (holiday?.id) {
        await dispatch(updateHoliday({ id: holiday.id, updatedData: data })).unwrap();
        alert("Holiday updated successfully!");
      } else {
        await dispatch(addHoliday(data)).unwrap();
        alert("Holiday added successfully!");
      }
      // Refresh holidays list after adding/updating
      await dispatch(fetchHolidays());
      reset();
      onClose();
    } catch (error) {
      console.error("Error saving holiday:", error);
      alert(error?.message || "Failed to save holiday. Please try again.");
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      if (holiday) {
        setValue("name", holiday.name || "");
        setValue("start", holiday.start ? holiday.start.split("T")[0] : "");
        setValue("end", holiday.end ? holiday.end.split("T")[0] : "");
        setValue("description", holiday.description || "");
      } else {
        // Reset form for new holiday
        reset({ name: "", start: "", end: "", description: "" });
      }
    }
  }, [holiday, setValue, isOpen, reset]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">{holiday ? "Edit Holiday" : "Add Holiday"}</h2>
          <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-300">
            X
          </button>
        </div>
        <form onSubmit={handleSubmit(submitForm)}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Holiday Name</label>
            <input
              type="text"
              {...register("name", { required: "Holiday name is required" })}
              className="w-full border rounded px-3 py-2"
            />
            {errors.name && <span className="text-red-500 text-sm">{errors.name.message}</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Start Date</label>
            <input
              type="date"
              {...register("start", { required: "Start date is required" })}
              className="w-full border rounded px-3 py-2"
            />
            {errors.start && <span className="text-red-500 text-sm">{errors.start.message}</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">End Date</label>
            <input
              type="date"
              {...register("end", { required: "End date is required" })}
              className="w-full border rounded px-3 py-2"
            />
            {errors.end && <span className="text-red-500 text-sm">{errors.end.message}</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Description</label>
            <textarea
              {...register("description", { required: "Description is required" })}
              className="w-full border rounded px-3 py-2"
            ></textarea>
            {errors.description && (
              <span className="text-red-500 text-sm">{errors.description.message}</span>
            )}
          </div>
          <div className="flex justify-end">
            <button type="submit" className="px-4 py-2 rounded bg-blue-500 text-white">
              {holiday ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HolidayModal;